import React from 'react';

import { Modal } from 'src/components/common';
import { InvitePeoByCVStaffModalForm } from 'src/components/peo';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const InvitePeoByCVStaffModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(ModalId.InvitePeoByCVStaffModal);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite PEOs"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <InvitePeoByCVStaffModalForm
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
